import { render, staticRenderFns } from "./Home-item-detalle.vue?vue&type=template&id=ca7f3640&scoped=true&lang=pug"
import script from "./Home-item-detalle.vue?vue&type=script&lang=js"
export * from "./Home-item-detalle.vue?vue&type=script&lang=js"
import style0 from "./Home-item-detalle.vue?vue&type=style&index=0&id=ca7f3640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7f3640",
  null
  
)

export default component.exports